module.exports = __webpack_public_path__ + "img/photo-lifestyle-resto-partner.17279a4c.png";